module.exports = __webpack_public_path__ + "img/search.1530ccf3.png";